import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BuilderContext, useDrawer } from "react-flow-builder";
import { Form, Button, Input, Select, Radio, Checkbox } from "antd";
import { store } from "../../../../../../../redux";
import { setDraft } from "../../../../../../../redux/actions/skill";
import { notify } from "../../../../../../../redux/actions/snackActions";
import { colorcodes } from "../../../../../../../utility/colorCodes";
import { v4 as uuid } from "uuid";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";

const { Option } = Select;

const CsvConfig = () => {
  const dispatch = useDispatch();
  let { selectedNode: node, flowVariables, nodes } = useContext(BuilderContext);
  const { closeDrawer: cancel } = useDrawer();
  const [nodeData, setNodeData] = useState(null);
  const [actionType, setActionType] = useState("");
  const [form] = Form.useForm();
  const variables = useSelector((state) => state.skillReducer?.trainDraft?.RAW_DATA?.variables);

  const findAndUpdate = (arr, id, payload) => {
    let found = arr.findIndex((i) => i.id == id);
    if (found > -1) {
      arr[found] = { ...arr[found], ...payload };
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          findAndUpdate(element.children, id, payload);
        }
      });
    }
    return arr;
  };

  const validateVariableName = (variableName) => {
    if (variableName && variableName.includes('-') || variableName.includes(' ')) {
      return false;
    }
    return true;
  };

 const newVariables = useSelector((state=> state.skillReducer?.trainDraft?.RAW_DATA?.variables))

  const handleSubmit = async (validate) => {
    try {
      let values;
      if (validate === false) {
        values = form.getFieldsValue();
      } else {
        values = await form.validateFields();
        if (values.CsvArray == null) {
        }
        else if (!validateVariableName(values.CsvArray)) {
          dispatch(
            notify(
              "error",
              "Invalid variable name. The use of '-' symbol and spaces are not allowed in variable names."
            )
          );
          return;
        }
      }
      let {
        skillReducer: { trainDraft },
      } = store.getState();
      console.log(values, "dsdsd");
      if (actionType === "CSV_HEADER") {
        nodeData.actionType = "CSV_HEADER";
        nodeData["CsvFileName"] = values.CsvFileName;
        nodeData["value"] = values.value;

        nodeData.label = "CSV Header";
        nodeData.key = "csvheader";
      } else if (actionType === "CSV_ROW") {
        nodeData.actionType = "CSV_ROW";
        nodeData["CsvFileName"] = values.CsvFileName;
        nodeData["CsvArray"] = values.CsvArray;
        nodeData.label = "CSV Row";
        nodeData.key = "csvrow";
      } else if (actionType === "" || "select") {
        dispatch(
          notify(
            "error",
            "Please select operation."
          )
        );
        return;
      }
      
      nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
      let newActions = findAndUpdate(nodes, nodeData.id, nodeData);

      store.dispatch(
        setDraft({
          ...trainDraft,
          RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
        })
      );
      console.log(newActions, "new");
      if (validate === true) cancel();
    } catch (error) {
      console.log("form error: ", error.toString());
    }
  };
  const handleTypeChange = (e) => {
    setActionType(e.target.value);
  };

  const renderActionFields = (type) => {
    switch (type) {
      case "CSV_HEADER":
        return (
          <div>
            <Form.Item
              name="CsvFileName"
              label="CSV File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.csv "
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="value"
              label="Value"
              help="Eg: List of array"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </div>
        );

      case "CSV_ROW":
        return (
          <div>
            <Form.Item
              name="CsvFileName"
              label="CSV File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.csv "
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="CsvArray"
              label="Select Variable"
              rules={[{ required: true }]}
            >
              <Select>
              {variables
                  ?.filter(variable => variable.dataType === "list")
                .map((variable) => (
                  <Option key={variable.id} value={variable.name}>
                    {variable.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    setNodeData(node);
    setActionType(node.actionType === "CSV" ? "" : node.actionType);
  }, [node]);

  const onChange = (allFields) => {
    handleSubmit(false);
  };
  return (
    <div>
      {nodeData ? (
        <div>
          <Form
            className=""
            form={form}
            initialValues={nodeData}
            onValuesChange={(_, allFields) => {
              onChange(allFields);
            }}
          >
            <div className="ant-row ant-form-item">
              <label className="ant-form-item-required">
                Select Operation
              </label>
              <div className="ant-col ant-form-item-control">
                <select
                  className="ant-input"
                  style={{ padding: "10px" }}
                  value={actionType}
                  onChange={(e) => handleTypeChange(e)}
                >
                  <option value="select">Select</option>
                  <option value="CSV_HEADER">CSV Header</option>
                  <option value="CSV_ROW">CSV Row</option>
                </select>
              </div>
            </div>




            {renderActionFields(actionType)}
          </Form>

          <div>
            <Button onClick={cancel}> Cancel </Button>
            <Button
              type="primary"
              onClick={() => {
                handleSubmit(true);
              }}
            >
              Save
            </Button>
          </div>
        </div>
      ) : null}
      <ul className="note-list">
        {(() => {
          if (actionType === "CSV_HEADER") {
            return (
              <li>
                Overwrites the provided data at the header of the specified CSV file.
              </li>
            );
          } else if (actionType === "CSV_ROW") {
            return (
              <li>
                Writes the given data into row in the CSV file
              </li>
            );
          } else {
            return null;
          }
        })()}
      </ul>
    </div>
  );
};

export default CsvConfig;
